import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "../App";

const CompetitorContext = createContext();

export function useCompetitors() {
  return useContext(CompetitorContext);
}

export function CompetitorProvider({ children }) {
  const { user } = useAuth();
  const [competitors, setCompetitors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user) return;

    const fetchCompetitors = async () => {
      try {
        setLoading(true);
        setError(null);

        const token = localStorage.getItem("authToken");
        if (!token) throw new Error("No authentication token found.");

        const response = await fetch("/.netlify/functions/fetchAll", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch competitors");
        }

        const data = await response.json();
        setCompetitors(data);
      } catch (err) {
        console.error("Error fetching competitors:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCompetitors();
  }, [user]);

  return (
    <CompetitorContext.Provider value={{ competitors, loading, error }}>
      {children}
    </CompetitorContext.Provider>
  );
}
